import { PadBox } from 'component/basics';
import { DropDownSelector, Popup, PopupPanel, PopupTip } from 'component/popup';
import { UtilityText } from 'component/text';
import { CHECK_TEXT, CLICK, component, componentWithVariants, demoFile, story, variant } from 'system/demo';
import { t } from 'util/stdtypes';

demoFile('component/popup');

function PopupPanelDemo({ testID, alignRight, popupContent, label }) {
    return (
        <PopupPanel alignRight={alignRight} popupContent={popupContent} testID={testID}>
            <UtilityText text={label} />
        </PopupPanel>
    );
}

componentWithVariants('PopupPanel', PopupPanelDemo, {}, [
    variant(
        'Default',
        {
            args: {
                testID: 'popup-panel',
                label: t('Open Popup'),
                popupContent: () => <UtilityText text='Popup content' />,
                alignRight: false,
            },
        },
        [
            story('Open', [CLICK('popup-panel'), CHECK_TEXT('Popup content')]),
            story('Open and Close', [CLICK('popup-panel'), CLICK('popup-panel'), CHECK_TEXT('Open Popup')]),
        ],
    ),
    variant(
        'Align Right',
        {
            args: {
                testID: 'popup-right',
                label: t('Open Right Popup'),
                popupContent: () => <UtilityText text='Right popup' />,
                alignRight: true,
            },
        },
        [story('Show Right', [CLICK('popup-right'), CHECK_TEXT('Right popup')])],
    ),
]);

componentWithVariants(
    'DropDownSelector',
    DropDownSelector,
    {
        args: {
            options: [
                { key: 'a', label: t('!A') },
                { key: 'b', label: t('!B') },
            ],
            value: 'a',
            onChange: () => {},
        },
    },
    [
        variant('Default', { args: { testID: 'dropdown', text: 'Sort' } }, [story('Select', [CLICK('dropdown'), CLICK('!B')])]),
        variant('No Label', { args: { testID: 'dropdown-none' } }, [story('Open Menu', [CLICK('dropdown-none'), CHECK_TEXT('B')])]),
    ],
);

function PopupDemo() {
    return (
        <Popup popupContent={() => <UtilityText text='Base popup' />} testID='popup-base'>
            <UtilityText text='Open Base Popup' />
        </Popup>
    );
}

component('Popup', PopupDemo, {}, [story('Basic', [CLICK('popup-base'), CHECK_TEXT('Base popup')])]);

function PopupTipDemo() {
    return (
        <>
            <PopupTip
                label={t(
                    '!This is the inside of the popup content. The content is a bit longer than the label. The text just keeps going and going and going.',
                )}
            />
            <PadBox bottom={100} top={100}>
                <UtilityText text='Extra space for the popup to fit.' />
            </PadBox>
        </>
    );
}

component('PopupTip', PopupTipDemo, {}, [
    story('Basic', [
        CLICK('popup-tip'),
        CHECK_TEXT(
            'This is the inside of the popup content. The content is a bit longer than the label. The text just keeps going and going and going.',
        ),
    ]),
]);
